import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

interface NavButtonProps {
  title: string;
  id?: string;
  url: string;
  colorInvert?: boolean;
}

const NavButton = ({ title, id, url, colorInvert = false }: NavButtonProps) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [activeLink, setActiveLink] = useState('');

  const handleClick = () => {
    navigate(url);
  };

  const linkColor = colorInvert ? 'common.white' : 'text.primary';

  useEffect(() => {
    setActiveLink(window && window.location ? window.location.pathname : '');
  }, []);

  return (
    <Box>
      <Box
        display={'flex'}
        alignItems={'center'}
        aria-describedby={id}
        sx={{
          cursor: 'pointer',
          padding: theme.spacing(1),
          transition: 'background-color 0.3s ease',
        }}
        onClick={handleClick}
      >
        <Typography
          data-text={title}
          fontWeight={activeLink === url ? 700 : 400}
          color={linkColor}
          sx={{
            position: 'relative',
            '&::after': {
              content: 'attr(data-text)',
              display: 'block',
              height: 0,
              overflow: 'hidden',
              visibility: 'hidden',
              fontWeight: 700,
            },
            '&:hover': {
              fontWeight: 600,
            },
          }}
        >
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

export default NavButton;
